/**
 * Created by sange on 22/08/2017.
 */

export enum ConversationType {
  Open = 'open',
  Closed = 'closed',
  Unassigned = 'unassigned',
  Mine = 'mine',
}



// WEBPACK FOOTER //
// ./src/app/shared/conversation/conversation-type.ts